import { authHeader } from '@/_helpers';
import {userService} from "@/_services/user.service";
import {API_URL} from "../config/app";

const URL = API_URL

export const companiesService = {
  getAll,
  createCompany,
  showCompany,
  updateCompany
};

function getAll(page, sort, search) {

  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  let parameters = '?page=' + page;
  if (sort) {
    parameters += '&sort=' + sort
  }

  return fetch(URL + "/companies" + parameters, requestOptions)
    .then(handleResponse)
    .then(response => {

      let data = [];
      response.data.forEach(resp => {
        data.push({
          id: resp.id,
          name: resp.attributes.name,
          role: resp.attributes.role,
          logo: resp.attributes.logo,
          created_at: resp.attributes.created_at,
          updated_at: resp.attributes.updated_at
        });
      })

      return Promise.resolve({
        data,
        pagination: response.meta[0].page
      })
    })

}

function createCompany(company) {

  let formData = new FormData()
  formData.append("name", company.name);
  if (company.logo) {
    formData.append("logo", company.logo)
  }

  let headers = authHeader();
  delete headers['Content-Type']

  const requestOptions = {
    method: 'POST',
    headers: headers,
    body: formData
  };

  return fetch(URL + "/companies", requestOptions).then(handleResponse);
}

function showCompany(company) {

  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(URL + "/companies/" + company, requestOptions)
    .then(handleResponse)
    .then(response => {

      return Promise.resolve( {
        id: response.data[0].id,
        name: response.data[0].attributes.name,
        role: response.data[0].attributes.role,
        logo: response.data[0].attributes.logo,
        created_at: response.data[0].attributes.created_at,
        updated_at: response.data[0].attributes.updated_at
      });

    })

}

function updateCompany(company) {

  let formData = new FormData()
  formData.append("name", company.name);
  if (company.logo) {
    formData.append("logo", company.logo)
  }

  let headers = authHeader();
  delete headers['Content-Type']

  const requestOptions = {
    method: 'PATCH',
    headers: headers,
    body: formData
  };

  return fetch(URL + "/companies/" + company.id, requestOptions).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        userService.refreshToken();
        return Promise.reject("Intentando recuperar la sesión");
      }

      const error = (data && data.errors[0].detail) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}
